var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 72 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "house") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Proto",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Front-Page-v3",
    transform: "translate(-499.000000, -938.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(435.000000, 870.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "house-(1)",
    transform: "translate(64.000000, 68.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.9374947,28.7125 C72.1999947,29.7875 72.3624947,31.675 71.2874947,32.9375 C70.2124947,34.2 68.3249947,34.3625 67.0624947,33.2875 L64,30.6875 L64,54 C64,59.525 59.5249947,64 54,64 L18,64 C12.4774947,64 8,59.525 8,54 L8,30.6875 L4.9412447,33.2875 C3.6774947,34.3625 1.7849947,34.2 0.712494697,32.9375 C-0.359380303,31.675 -0.204255303,29.7875 1.0591197,28.7125 L34.0624947,0.7125 C35.1749947,-0.2375 36.8249947,-0.2375 37.9374947,0.7125 L70.9374947,28.7125 Z M17.9999947,58 L23.9999947,58 L23.9999947,39 C23.9999947,36.2375 26.2374947,34 28.9999947,34 L42.9999947,34 C45.7624947,34 47.9999947,36.2375 47.9999947,39 L47.9999947,58 L53.9999947,58 C56.2124947,58 57.9999947,56.2125 57.9999947,54 L57.9999947,25.6 L35.9999947,6.93375 L13.9999947,25.6 L13.9999947,54 C13.9999947,56.2125 15.7874947,58 17.9999947,58 L17.9999947,58 Z M29.9999947,58 L41.9999947,58 L41.9999947,40 L29.9999947,40 L29.9999947,58 Z",
    id: "Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.bc28263963ab49b881deba994f7fe60a.svg";
export { ForwardRef as ReactComponent };